<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group label="Entity">
      <b-form-checkbox
        v-for="option in entityOptions"
        :key="option._id"
        v-model="entityValue"
        :value="option._id"
        name="flavour-3a"
      >
        {{ option.name }}
      </b-form-checkbox>
    </b-form-group>
    <hr class="dividerHR filter-divider">
    <b-form-group
      label="Evaluation Period"
    >
      <b-input-group>
        <flat-pickr
          v-model="periodFilterValue"
          class="form-control"
          placeholder="Select Date Range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-button
      variant="outline-primary"
      size="sm"
      class="mr-1"
      @click="clearFilter"
    >
      Clear All
    </b-button>
    <b-button
      variant="primary"
      size="sm"
      @click="applyFilter"
    >
      Apply Filter
    </b-button>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol, BFormCheckbox, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    BFormCheckbox,
    BInputGroup,
    BInputGroupAppend,
    flatPickr,
  },
  props: {
    entity: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    periodFilter: {
      type: [String, null],
      default: null,
    },
    entityOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      periodFilterValue: this.periodFilter,
      entityValue: JSON.parse(JSON.stringify(this.entity)) || [],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
    }
  },
  watch: {
    periodFilter: {
      immediate: true,
      handler(val) {
        this.periodFilterValue = val
      },
    },
    entity: {
      immediate: true,
      handler(val) {
        this.entityValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    showAgainDropdown() {
      if (this.periodFilterValue) {
        this.$emit('emitShowFilter')
      }
    },
    applyFilter() {
      this.$emit('update:period', this.periodFilterValue)
      this.$emit('update:entity', this.entityValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.periodFilterValue = ''
      this.entityValue = []
      this.$emit('update:period', this.periodFilterValue)
      this.$emit('update:entity', this.entityValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
